import { SensorScatterplotTable } from 'features/timeSeries'
import React from 'react'
import styled from 'styled-components'

import { YAxisModeSection } from './YAxisModeSection'

const TableContainer = styled.div`
  padding: 0.25rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 1rem;
`

const ConfigContainer = styled.div`
  margin-top: auto;
`

export const PensTab: React.FC = () => {
  return (
    <TableContainer>
      <SensorScatterplotTable />
      <ConfigContainer>
        <YAxisModeSection />
      </ConfigContainer>
    </TableContainer>
  )
}
